function switchBG() {
        document.querySelectorAll('.conf-bg-img')[0].classList.toggle('opacity');
        document.querySelectorAll('.conf-bg-img2')[0].classList.toggle('opacity2');
        document.querySelector('.knob-bg').classList.toggle('knob-off');

        //moody background
        document.querySelectorAll('#mybike')[0].classList.toggle('my-bike-mood');
        document.querySelectorAll('.grain-bg')[0].classList.toggle('hidden');
        document.querySelectorAll('.conf-bg')[0].classList.toggle('my-bike-mood-bg');

        document.querySelectorAll('.conf-bg-switch')[0].classList.toggle('conf-bg-switch-bright');

}
document.querySelector('.switch-bg').addEventListener('click', switchBG)

function confPanelSwitch() {
        document.querySelector('.conf-panel').classList.toggle('conf-panel-close');
        document.querySelector('.knob-panel').classList.toggle('knob-off');
        document.querySelector('.bike-frame').classList.toggle('bike-frame-centered')
        document.querySelectorAll('.conf-desc')[0].classList.toggle('opacity3');
        document.querySelectorAll('.conf-desc2')[0].classList.toggle('opacity3');

}
document.querySelector('.switch-panel').addEventListener('click', confPanelSwitch)


//selected stock gty
let selectedSize;
for (let i = 0; i < document.querySelectorAll('.size').length; i++) {
        document.querySelectorAll('.size')[i].addEventListener('mouseenter', function () {
                document.querySelector('.status-field').innerText = document.querySelectorAll('.size')[i].attributes.stock.nodeValue;
        })
        document.querySelectorAll('.size')[i].addEventListener('mouseleave', function () {

                if (document.querySelector('.size.selected').attributes.stock.nodeValue) {

                        document.querySelector('.status-field').innerText =
                                document.querySelector('.size.selected').attributes.stock.nodeValue;
                }
        }
        )
}
//size selector
for (let i = 0; i < document.querySelectorAll('.size').length; i++) {
        document.querySelectorAll('.size')[i].addEventListener('click', function () {
                for (let i = 0; i < document.querySelectorAll('.size').length; i++) {
                        document.querySelectorAll('.size')[i].classList.remove('selected')
                }
                document.querySelectorAll('.size')[i].classList.add('selected');

                //update indicator size
                document.querySelector('.add-to-cart-indicator-block-1').classList.remove('add-to-cart-indicator-block-inactive')

                //slide options
                for (let i = 0; i < document.querySelectorAll('.conf-box').length; i++) {
                        document.querySelectorAll('.conf-box')[i].classList.remove('conf-box-part-inactive')
                }

                //unlock size conf box
                document.querySelector('.conf-box-main').classList.remove('conf-box-fixed')

        })
}


//color variant hover
for (let i = 0; i < document.querySelectorAll('.color').length; i++) {
    document.querySelectorAll('.color')[i].addEventListener('mouseenter', function () {
       document.querySelector('.conf-color-selected').innerText = document.querySelectorAll('.color')[i].dataset.color
    })
   document.querySelectorAll('.color')[i].addEventListener('mouseleave', function () {
       document.querySelector('.conf-color-selected').innerText = colorVariantSelected
    })
}

//hide gallery imgs - show first set
for (let z = 0; z < document.querySelectorAll('.slider-variant-imgs').length; z++) {
document.querySelectorAll('.slider-variant-imgs')[z].classList.add('hide')}
document.querySelectorAll('.slider-variant-imgs')[0].classList.remove('hide');



let basePrice = Number(document.querySelector('.price').innerText.replace(/[^0-9]/g, '')) / 100;


// Color variant select on click
const colorElements = document.querySelectorAll('.color');
for (let i = 0; i < colorElements.length; i++) {
    const element = colorElements[i];
    const index = i; // Capture the current index
    element.addEventListener('click', function() {

        // Update basePrice variable with calculation and keep it as a number
        basePrice = Number(document.querySelectorAll('.variant-base-price')[index].innerText) * 1.19 / 100;

        console.log('New base price: ' + basePrice);

        // Call calcOptions() to update the displayed price
        calcOptions();

        colorVariantSelected = element.dataset.color;
        document.querySelector('.conf-color-selected').innerText = colorVariantSelected;

        // Remove 'selected' class from all color options
        for (let j = 0; j < colorElements.length; j++) {
            colorElements[j].classList.remove('selected');
        }
        element.classList.add('selected');

        // Change gallery images
        const sliderImages = document.querySelectorAll('.slider-variant-imgs');
        for (let z = 0; z < sliderImages.length; z++) {
            sliderImages[z].classList.add('hide');
        }
        sliderImages[index].classList.remove('hide');

        // Change mybike image
        const myBikeImages = document.querySelectorAll('.mybike-img');
        for (let z = 0; z < myBikeImages.length; z++) {
            myBikeImages[z].classList.add('hide');
        }
        myBikeImages[index].classList.remove('hide');

        // Change frame image
        const bikeFrameImg = document.querySelector(".bike-frame-img");
        bikeFrameImg.classList.add('changepart');
        bikeFrameImg.src = element.dataset.img;
        setTimeout(function () {
            bikeFrameImg.classList.remove('changepart');
        }, 90);

        // Show size variants
        const sizeOptions = document.querySelectorAll('.conf-size-options');
        for (let j = 0; j < sizeOptions.length; j++) {
            sizeOptions[j].classList.add('hidden');
        }
        sizeOptions[index].classList.remove('hidden');

        // Update the URL parameter 'color' to the current index without reloading the page
        const url = new URL(window.location);
        url.searchParams.set('color', index);
        window.history.replaceState({}, '', url);

        // Reset add to cart button
        document.querySelector('.conf-panel-mobile-bttn').innerText = 'Select size';
        document.querySelector('.conf-panel-mobile-bttn').classList.add('add-to-cart-deactive');
        document.querySelector('.add-to-cart-bttn').innerText = 'Select size';
        document.querySelector('.add-to-cart-bttn').classList.add('add-to-cart-deactive');
        sizeSelected = 0;



      //update admin
     if (typeof addSelectionToAdmin === 'function') {
    addSelectionToAdmin();
    }
    });
}



//color variant stock list
document.querySelectorAll('.conf-size-options').forEach(element => {
    element.classList.add('hidden')
});
document.querySelector('.conf-size-options').classList.remove('hidden');





//activate first grp itm
function clickOnFirstGroupItems() {
    const confBoxes = document.querySelectorAll('.conf-box');

    confBoxes.forEach(confBox => {
        const groupItem = confBox.querySelector('.group-itm');
        if (groupItem) {
            groupItem.click();
                groupItem.classList.add('conf-selected');
        }
    });
}






//mark selected part as active
document.addEventListener('DOMContentLoaded', function() {
    // Assign data-confBox to each conf-box-part and build group mappings
    const confBoxes = document.querySelectorAll('.conf-box-part');
    const groupsById = {};
    const groupsByName = {};
    const selectedOptions = {}; // To keep track of selected options in each group

    confBoxes.forEach((confBox, i) => {
        confBox.setAttribute("data-confBox", i);

        const groupName = confBox.querySelector('.subtitle').textContent.trim();
        const dataConditional = confBox.getAttribute('data-conditional');
        const conditionBound = confBox.getAttribute('data-condition-bound');
        const conditionIs = confBox.getAttribute('data-condition-is');

        // Extract className from confBox class list
        const classList = Array.from(confBox.classList);
        const className = classList.find(cls => {
            return cls.startsWith('conf-box-') && ![
                'conf-box-part',
                'conf-box-part-Main',
                'conf-box',
                'conf-box-part-Upgrade',
                'sub-box'
            ].includes(cls);
        });
        let classNameFormatted = '';
        if (className) {
            classNameFormatted = className.replace('conf-box-', '').trim();
            // Handle cases where class names have spaces or special characters
            classNameFormatted = classNameFormatted.replace(/\s+/g, '-').toLowerCase();
        }

        // Build groupsById
        groupsById[i] = {
            groupName: groupName,
            className: classNameFormatted,
            dataConditional: dataConditional,
            conditionBound: conditionBound,
            conditionIs: conditionIs,
            dependentGroups: [],
            boundGroupIds: []
        };

        // Build groupsByName
        if (!groupsByName[groupName]) {
            groupsByName[groupName] = [];
        }
        groupsByName[groupName].push(i);

        // Assign data-confSet to each group-itm within the confBox
        const groupItems = confBox.querySelectorAll('.group-itm');
        groupItems.forEach(item => {
            item.setAttribute("data-confSet", i);
        });
    });

    // Build dependencies between groups
    Object.keys(groupsById).forEach(groupId => {
        const groupData = groupsById[groupId];
        if (groupData.dataConditional === "true") {
            const conditionBoundGroupName = groupData.conditionBound;
            const boundGroupNames = conditionBoundGroupName.split(';').map(name => name.trim());
            boundGroupNames.forEach(boundName => {
                const boundGroupIds = groupsByName[boundName];
                if (boundGroupIds) {
                    boundGroupIds.forEach(boundGroupId => {
                        if (!groupsById[boundGroupId].dependentGroups) {
                            groupsById[boundGroupId].dependentGroups = [];
                        }
                        groupsById[boundGroupId].dependentGroups.push(groupId);

                        // Keep track of which groups this group is bound to
                        if (!groupsById[groupId].boundGroupIds.includes(boundGroupId)) {
                            groupsById[groupId].boundGroupIds.push(boundGroupId);
                        }
                    });
                }
            });
        }
    });

    // Function to handle selection logic
    function selectOption(groupItem) {
        const dataConfset = groupItem.getAttribute('data-confset');
        const groupId = dataConfset;
        const groupData = groupsById[groupId];

        // Deselect all items in the same group
        const sameGroupItems = document.querySelectorAll(`[data-confset="${dataConfset}"]`);
        sameGroupItems.forEach(item => {
            item.classList.remove('conf-selected');
        });

        // Select the clicked item
        groupItem.classList.add('conf-selected');

        // Update the selected option for this group
        const selectedOptionTitle = groupItem.querySelector('.group-itm-title').textContent.trim();
        selectedOptions[groupId] = selectedOptionTitle;

        // Update image for the current selection
        updateImageForSelection(groupItem);

        // Now, check for dependent groups
        if (groupData && groupData.dependentGroups && groupData.dependentGroups.length > 0) {
            // For each dependent group
            groupData.dependentGroups.forEach(dependentGroupId => {
                const dependentGroupData = groupsById[dependentGroupId];

                // Check if the condition is still satisfied
                const conditionIs = dependentGroupData.conditionIs;
                const conditions = conditionIs.split(';').map(c => c.trim());

                let conditionMet = false;

                // For each bound group, check if any selected option meets the condition
                for (let boundGroupId of dependentGroupData.boundGroupIds) {
                    const boundGroupSelectedOption = selectedOptions[boundGroupId];
                    if (boundGroupSelectedOption && conditions.includes(boundGroupSelectedOption)) {
                        conditionMet = true;
                        break;
                    }
                }

                if (!conditionMet) {
                    // Deselect any selections in the dependent group
                    const dependentGroupItems = document.querySelectorAll(`[data-confset="${dependentGroupId}"]`);
                    dependentGroupItems.forEach(item => {
                        item.classList.remove('conf-selected');
                    });

                    // Reset the image for the dependent group
                    if (dependentGroupData && dependentGroupData.className) {
                        const imgElement = document.querySelector('.bike-' + dependentGroupData.className + '-img');
                        if (imgElement) {
                            imgElement.src = 'https://cdn.shopify.com/s/files/1/0830/1771/files/1x1-00000000.png?v=1729679077';
                        }
                    }

                    // Remove the selected option from the tracking
                    delete selectedOptions[dependentGroupId];
                }
            });
          calcOptions() 
        }
    }

    // Add event listener to group-itm elements
    const groupItems = document.querySelectorAll('.group-itm');
    groupItems.forEach(groupItem => {
        groupItem.addEventListener('click', function () {
            selectOption(groupItem);
          if (typeof addSelectionToAdmin === 'function') {
    addSelectionToAdmin();
}
        });
    });

    // Function to update images for selections
    function updateImageForSelection(element) {
        const classNames = element.className.split(' ');
        const className = classNames.find(cls => cls.endsWith('-slct'));
        if (className) {
            const baseClassName = className.replace('-slct', '');
            const imgElement = document.querySelector('.bike-' + baseClassName + '-img');
            if (imgElement) {
                imgElement.classList.add('changepart');
                imgElement.src = element.getAttribute('img') || 'https://cdn.shopify.com/s/files/1/0830/1771/files/1x1-00000000.png?v=1729679077';
                setTimeout(function () {
                    imgElement.classList.remove('changepart');
                }, 120);
            }
        }
    }

    // Handle preselection of options
    confBoxes.forEach(confBox => {
        if (confBox.hasAttribute('data-preselect')) {
            const dataPreselect = confBox.getAttribute('data-preselect');
            const preselectIndex = parseInt(dataPreselect) - 1; // Convert to zero-based index
            const groupItems = confBox.querySelectorAll('.group-itm');
            if (groupItems[preselectIndex]) {
                selectOption(groupItems[preselectIndex]);
            }
        }
    });
});







// Get all selected variants
function getSelectedItems() {
    const selectedItems = [];
    const confSelectedElements = document.querySelectorAll('.conf-selected');
    const sizeElement = document.querySelector('.size.selected');

    confSelectedElements.forEach(element => {
        const itmId = element.dataset.itmId;
        selectedItems.push({ id: itmId, quantity: 1 });
    });

    if (sizeElement) {
        const itmId = sizeElement.dataset.variantId;
        selectedItems.push({ id: itmId, quantity: 1 });
    }

    return selectedItems;
}

function updateCartUI(cartData) {
    // Update the cart UI here with the new cart data
    console.log('Cart updated', cartData);
}

// Add all selected variants to cart with a single AJAX request
async function addToCart() {
    const selectedItems = getSelectedItems();

    if (!Array.isArray(selectedItems)) {
        console.error('Selected items must be an array.');
        return;
    }

    const data = {
        items: selectedItems
    };

    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        const result = await response.json();
        console.log('Items added:', result);
        updateCartUI(result);

    } catch (error) {
        console.error('Error adding items:', error);
    }
}





//check cart itms
function checkCart() {
    // Create a new XMLHttpRequest object
    const xhr = new XMLHttpRequest();

    // Set the request URL
    const url = '/cart.js';

    // Set the request method to GET
    xhr.open('GET', url, true);

    // Set the request header
    xhr.setRequestHeader('Content-Type', 'application/json');

    // Set the onload callback function
    xhr.onload = function() {
        if (xhr.status === 200) {
            // Parse the response JSON
            const response = JSON.parse(xhr.responseText);

            // Access the cart items
            const cartItems = response.items;

            // Do something with the cart items
            console.log(cartItems);
        } else {
            // Handle the error
            console.error('Error:', xhr.status);
        }
    };

    // Send the request
    xhr.send();
}


//toggle shadow
function toggleShadow(){
for (let i = 0; i < document.querySelectorAll('.bike-shadowback').length; i++) {
    document.querySelectorAll('.bike-shadowback')[i].classList.remove('shadow-trans')   
}}

for (let i = 0; i < document.querySelectorAll('.wheelset-slct').length; i++) {
    document.querySelectorAll('.wheelset-slct')[i].addEventListener('click', toggleShadow)
}




  //content space top
        if (screen.width > 1200) {
            //margin content top
            document.querySelector('.content-body').style.marginTop = document.querySelector('.conf-panel ').offsetHeight + 800 + 'px'
        }
        else {

        }

        //margin content top
        document.querySelector('.content-body').style.marginTop = document.querySelector('.conf-panel ').offsetHeight + 3500 + 'px'




 // Cache DOM elements
const confScrollWrapper = document.querySelector(".conf-scroll-wrapper");
const confBoxes = confScrollWrapper.getElementsByClassName("conf-box");
const numConfBoxes = confBoxes.length;
const partsList = document.querySelector('.parts-conf-list');
const sizeBox = document.querySelector('.conf-box-size');
const confBgContainer = document.querySelector('.conf-bg-container');
const contentBody = document.querySelector('.content-body');
const confPanel = document.querySelector('.conf-panel');
const myBike = document.querySelector('#mybike');
const screenWidth = window.screen.width;

let ticking = false;

window.addEventListener('scroll', onScroll, false);

function onScroll() {
    if (!ticking) {
        window.requestAnimationFrame(function() {
            doScroll(window.scrollY);
            ticking = false;
        });
        ticking = true;
    }
}

function doScroll(scrollY) {
    const offsetAdjustment = (screenWidth > 1200) ? 200 : 0;

    // Transform conf-box elements
partsList.style.transform = `translateY(${-scrollY}px)`;
  sizeBox.style.transform = `translateY(${-scrollY}px)`;

  
    if (confScrollWrapper.offsetHeight - offsetAdjustment >= scrollY) {
        confBgContainer.style.marginTop = "0px";
    }

    if (zoomed === 1) {
        myBike.click();
    }

    if (screenWidth > 1200) {
        // Price box handling for desktop
        if (contentBody.getBoundingClientRect().top < 3200) {
            confPanel.classList.add('conf-panel-scrolled');
        } else {
            confPanel.classList.remove('conf-panel-scrolled');
        }
    }
}





        //pop ups
        for (let i = 0; i < document.querySelector('.conf-box-main').querySelectorAll('.info-bttn').length; i++) {
            for (let i = 0; i < document.querySelectorAll('.pop-tab').length; i++) {
                document.querySelectorAll('.pop-tab')[i].classList.remove('active');
                document.querySelectorAll('.pop-page')[i].classList.add('hidden');
            }
            //update
            function updatePopups() {
                for (let i = 0; i < document.querySelectorAll('.pop-tab').length; i++) {
                    document.querySelectorAll('.pop-tab')[i].classList.remove('active');
                    document.querySelectorAll('.pop-page')[i].classList.add('hidden');
                }
                document.querySelectorAll('.pp-pop-bg')[0].classList.remove('inactive');
                document.querySelectorAll('.pop-tab')[i].classList.add('active');
                document.querySelectorAll('.pop-page')[i].classList.remove('hidden');
            }
            document.querySelectorAll('.info-bttn')[i].addEventListener('click', function () {
                updatePopups()
            })
        }
        //pop close
        for (let i = 0; i < document.querySelectorAll('.pop-close').length; i++) {
            document.querySelectorAll('.pop-close')[i].addEventListener('click', function () {
                for (let i = 0; i < document.querySelectorAll('.pp-pop-bg').length; i++) {
                    document.querySelectorAll('.pp-pop-bg')[i].classList.add('inactive')
                }
            })
        }



        //click tabs
        for (let i = 0; i < document.querySelectorAll('.pop-tab').length; i++) {
            document.querySelectorAll('.pop-tab')[i].addEventListener('click', function () {
                for (let i = 0; i < document.querySelectorAll('.pop-tab').length; i++) {
                    document.querySelectorAll('.pop-tab')[i].classList.remove('active');
                    document.querySelectorAll('.pop-page')[i].classList.add('hidden');
                }
                document.querySelectorAll('.pp-pop-bg')[0].classList.remove('inactive');
                document.querySelectorAll('.pop-tab')[i].classList.add('active');
                document.querySelectorAll('.pop-page')[i].classList.remove('hidden');
            })
        }

        //open review pop
document.querySelector('.pp-reviewsatars').addEventListener('click', function(){
document.querySelector('.pp-pop-review').classList.remove('inactive')
})
document.querySelector('.all-reviews-bttn').addEventListener('click', function(){
document.querySelector('.pp-pop-review').classList.remove('inactive')
})


//close all pop ups on bg click
for (let i = 0; i < document.querySelectorAll('.pp-pop-bg-closer').length; i++) {
    document.querySelectorAll('.pp-pop-bg-closer')[i].addEventListener('click', function(){
        for (let i = 0; i < document.querySelectorAll('.pp-pop-bg').length; i++) {
                    document.querySelectorAll('.pp-pop-bg')[i].classList.add('inactive')
                }

              document.querySelectorAll('.opt-detail-pop')[0].classList.add('inactive')
              document.querySelectorAll('.opt-details-pops')[0].classList.add('inactive')
})
}






        //mousemove
        let zoomed = 0;
        let cursorwhenzoomedx;
        let cursorwhenzoomedy;
        function getCursor(event) {
            if (zoomed == 0) {
            }
            else {
                let curx;
                let cury;
                curx = event.clientX;
                cury = event.clientY;
                console.log('zoomed1 y: ' + curx + 'x: ' + cury)
            }
        }
        //zoom
        let mousepos;
        document.querySelector('.bike-frame').addEventListener('click', function (event) {
            if (zoomed == 0) {
                zoomed = 1;
                console.log("clientX: " + event.clientX + " - clientY: " + event.clientY)
                cursorwhenzoomedx = event.clientX;
                cursorwhenzoomedy = event.clientY;
                let cursormovedx = cursorwhenzoomedx - event.clientX;
                let cursormovedy = cursorwhenzoomedy - event.clientY;
                document.querySelector('.bike-frame').style.transform = "scale(1.45) translateX(" + cursormovedx / 4.5 + "px) translateY(" + cursormovedy / 6 + "px)";
                document.querySelector('.conf-bg').style.transform = "scale(1.6) translateX(" + cursormovedx / 4.35 + "px) translateY(" + cursormovedy / 5 + "px)";
                document.querySelector('.conf-bg').style.transition = "none";
                document.querySelector('.bike-frame').style.transition = "none";
            }
            else {
                zoomed = 0;
                document.querySelector('.bike-frame').style.transform = "scale(1)";
                document.querySelector('.conf-bg').style.transform = "scale(1)"
                document.querySelector('.conf-bg').style.transition = "0.2s ease";
                document.querySelector('.bike-frame').style.transition = "0.2s ease";
            }
        })
        let mousex = 0;
        let mousey = 0;
        onmousemove = function (e) {
            if (zoomed == 1) {
                mousex = e.clientX;
                mousey = e.clientY;
                let cursormovedx = cursorwhenzoomedx - mousex;
                let cursormovedy = cursorwhenzoomedy - mousey;
                console.log("mouse1 location:", cursormovedx, cursormovedy)
                mousextravel =
                    document.querySelector('.bike-frame').style.transform = "scale(1.45) translateX(" + cursormovedx / 3.5 + "px) translateY(" + cursormovedy / 6 + "px)";
                document.querySelector('.conf-bg').style.transform = "scale(1.6) translateX(" + cursormovedx / 3.3 + "px) translateY(" + cursormovedy / 5.4 + "px)";
                document.querySelector('.conf-bg').style.transition = "none";
                document.querySelector('.bike-frame').style.transition = "none";
            }
        }
        //open details


        for (let i = 0; i < document.querySelectorAll('.info-bttn-detail').length; i++) {
            document.querySelectorAll('.info-bttn-detail')[i].addEventListener('click', function(){
                console.log(i);
                document.querySelector('.pop-col').querySelector('b').innerText = document.querySelectorAll('.info-bttn-detail')[i].dataset.descTitle;
                document.querySelector('.pop-copy-long').innerText = document.querySelectorAll('.info-bttn-detail')[i].dataset.descContent;
                document.querySelector('.pop-detail-img').src = document.querySelectorAll('.info-bttn-detail')[i].dataset.descImg;
                document.querySelectorAll('.opt-detail-pop')[0].classList.remove('inactive')
              document.querySelectorAll('.opt-details-pops')[0].classList.remove('inactive')

            })

        }


// Calculate item prices

function calcOptions() {
    let fullPrice = basePrice;
    console.log(`Base Price: ${basePrice.toFixed(2)} EUR`);

    document.querySelectorAll('.conf-box:not(.hidden) .conf-selected .group-itm-price').forEach(priceElement => {
        const price = Number(priceElement.innerText.replace(/[^0-9]/g, '')) / 100;
        console.log(`Option Price: ${price.toFixed(2)} EUR`);
        fullPrice += price;
    });

    const finalPrice = Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(fullPrice);
    document.getElementById('price-mobile').innerText = finalPrice;
    document.getElementById('price-desktop').innerText = finalPrice;

    const finalExprice = Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(fullPrice / 1.19);
    document.getElementById('exprice').innerText = `(${finalExprice} ex. VAT)`;



    
  const finalRate = Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(fullPrice / 4);
    document.querySelector('.price-rates u').innerText = `${finalRate}/month`;

    console.log(`Full Price: ${fullPrice.toFixed(2)} EUR`);
}

document.querySelectorAll('.group-itm').forEach(item => {
    item.addEventListener('click', function(){calcOptions();});
});


//check if all options are selected
function checkAllOptionsSelected(){
// Select all .conf-box-part-Main elements that do not have the .hidden class
var confBoxes = document.querySelectorAll('.conf-box-part-Main:not(.hidden)');

// Check if every conf-box (with a .group inside) has a .group-itm with the .conf-selected class
var allBoxesHaveSelectedItem = Array.from(confBoxes).every(confBox => {
  // Check if the .conf-box contains a .group element
  var group = confBox.querySelector('.group');
  
  // Only check those that contain a .group element
  if (group) {
    // Return true if there's a .group-itm with the .conf-selected class, otherwise false
    return group.querySelector('.group-itm.conf-selected') !== null;
  }
  
  // If no .group is found, ignore this box (i.e., treat it as passing)
  return true;
});

// Output the result: true if all applicable conf-boxes have a selected item, false otherwise
if (allBoxesHaveSelectedItem && sizeSelected != 1) {
  console.log('All applicable conf-boxes have a selected item, but size is NOT selected.');
  document.querySelector('.conf-panel-mobile-bttn').innerText = 'Select size';
  document.querySelector('.add-to-cart-bttn').innerText = 'Select size';
  document.querySelector('.add-to-cart-bttn').classList.add('add-to-cart-deactive');
  document.querySelector('.conf-panel-mobile-bttn').classList.add('add-to-cart-deactive');
  
} else if (allBoxesHaveSelectedItem && sizeSelected == 1) {
  console.log('All applicable conf-boxes have a selected item and size is selected.');
  document.querySelector('.conf-panel-mobile-bttn').innerText = 'Add to Cart';
  document.querySelector('.add-to-cart-bttn').innerText = 'Add to Cart';
  document.querySelector('.add-to-cart-bttn').classList.remove('add-to-cart-deactive');
  document.querySelector('.conf-panel-mobile-bttn').classList.remove('add-to-cart-deactive');
  
  // Update indicator config
  document.querySelector('.add-to-cart-indicator-block-2').classList.remove('add-to-cart-indicator-block-inactive');
  
} else {
  console.log('Not all applicable conf-boxes have a selected item.');
  document.querySelector('.conf-panel-mobile-bttn').innerText = 'Configure';
  document.querySelector('.add-to-cart-bttn').innerText = 'Configure';
  document.querySelector('.add-to-cart-bttn').classList.add('add-to-cart-deactive');
  document.querySelector('.conf-panel-mobile-bttn').classList.add('add-to-cart-deactive');
}
}








// Add all option variants and frame to cart with funny messages and product list popup
function addToCartOptions() {
    function getVariantData() {
        let variantData = [];

        // Collect IDs and names from elements with the class ".conf-selected" that do not have the ".hidden" class
        document.querySelectorAll('.conf-selected:not(.hidden)').forEach(element => {
            let variantId = element.getAttribute('data-itm-id');
            let variantName = element.getAttribute('data-itm-name') || element.textContent.trim();
            if (variantId) {
                variantData.push({ id: variantId, name: variantName });
            }
        });

        // Collect IDs and names from elements with the class ".conf-size-options .size .selected" that do not have the ".hidden" class
        document.querySelectorAll('.color-variant-list .conf-size-options:not(.hidden) .size.selected').forEach(element => {
            let variantId = element.getAttribute('data-variant-id');
            let variantName = element.getAttribute('data-variant-name') || element.textContent.trim();
            if (variantId) {
                variantData.push({ id: variantId, name: variantName });
            }
        });

        return variantData;
    }

    let funnyMessages = [
        "Checking your fancy parts",
      "Engineers are running final tests",
        "Sales team loves your slick configuration",
      "Logistics is planning the fastest route",
        "Warehouse is finishing coffee before picking",
        "Mechanics are approving the parts",
        "Marketing approves coolness",
        "Putting your bike parts together",
      "Our CEO is personally thanking you",
"Packaging team is adding extra care",
      "Quality assurance is giving a thumbs up",
      "Our mascot is cheering you on"
      
      
    ];
    let messageIndex = 0;
    let messageInterval;

    function startFunnyMessages() {
        let messageElem = document.getElementById('funny-message');
        if (!messageElem) return;

        // Display the first message immediately
        messageElem.textContent = funnyMessages[messageIndex];
        messageIndex = (messageIndex + 1) % funnyMessages.length;

        // Change messages every 1.5 seconds
        messageInterval = setInterval(() => {
            messageElem.textContent = funnyMessages[messageIndex];
            messageIndex = (messageIndex + 1) % funnyMessages.length;
        }, 1600);
    }

    function stopFunnyMessages() {
        clearInterval(messageInterval);
    }

    async function addToCartSequentially(variantData) {
        if (!Array.isArray(variantData)) {
            console.error('Variant data must be an array.');
            return;
        }

        // Start animation and messages
        showLoadingAnimation();
        startFunnyMessages();

        for (const item of variantData) {
            try {
                await addVariantToCart(item.id);
            } catch (error) {
                console.error('Error adding variant ID:', item.id, error);
            }
        }

        // Stop animation and messages
        hideLoadingAnimation();
        stopFunnyMessages();

        console.log('All items added successfully');
        updateCartUI();

        // Collect product names
        let productNames = variantData.map(item => item.name);

        // Show completion popup with product list
        showCompletionPopup(productNames);
    }

    function addVariantToCart(variantId) {
        let data = {
            id: variantId,
            quantity: 1
        };

        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
        });
    }

    function updateCartUI() {
        // Placeholder for updating the cart UI
        console.log('Cart updated');
    }

    // Function to show loading animation
    function showLoadingAnimation() {
        let overlay = document.getElementById('loading-overlay');
        if (overlay) {
            overlay.classList.remove('hidden');
        }
    }

    // Function to hide loading animation
    function hideLoadingAnimation() {
        let overlay = document.getElementById('loading-overlay');
        if (overlay) {
            overlay.classList.add('hidden');
        }
    }

    // Function to show completion popup
    function showCompletionPopup(productNames) {
        let popupOverlay = document.getElementById('popup-overlay');
        if (popupOverlay) {
            popupOverlay.classList.remove('hidden');

            // Update the popup content with the list of products
            let productListElem = document.getElementById('product-list');
            if (productListElem) {
                // Clear existing content
                productListElem.innerHTML = '';

                // Create list items for each product
                productNames.forEach(name => {
                    let li = document.createElement('li');
                    li.textContent = name;
                    productListElem.appendChild(li);
                });
            }

            // Attach event listener to close button
            let closeButton = document.getElementById('popup-close-button');
            if (closeButton) {
                closeButton.onclick = function() {
                    popupOverlay.classList.add('hidden');
                };
            }
        }
    }

    // Start the process
    let variantData = getVariantData();
    addToCartSequentially(variantData);
}









//size selector
for (let i = 0; i < document.querySelectorAll('.size').length; i++) {
        document.querySelectorAll('.size')[i].addEventListener('click', function () {
                sizeSelected = 1;
                if (configurationSelected == 1) {
                        checkAllOptionsSelected()

                }
                else {
                        checkAllOptionsSelected()

                }
                if (typeof addSelectionToAdmin === 'function') {
                        addSelectionToAdmin();
                }
        })
}





//animations
/*
        let animIn = anime({
            autoplay: false,
            targets: '.detailshot1',
            translateX: 0,
            duration: 1000,
            easing: 'easeOutSine'
        });

        const jadeScale = document.querySelectorAll(".content-body");
        const options = { rootMargin: "-150px" };

        const jadeScaleObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    animIn.play
                } else {
                }
            });
        }, options);

        jadeScale.forEach(function (jadeScale) {
            jadeScaleObserver.observe(jadeScale);
        }); */

// Define variables outside for scope access
var controller;




/*
// Function to initialize ScrollMagic
function initScrollMagic() {
    // Initialize ScrollMagic Controller
    controller = new ScrollMagic.Controller({ loglevel: 1 });

    var scrollHorizontal = new TimelineLite();
    scrollHorizontal.to("#scrollHorizontal", 1, { x: '-90%' });

    var horizontalScroll = new ScrollMagic.Scene({
        triggerElement: "#trigger-scroller",
        triggerHook: 'onLeave',
        duration: 8000,
        offset: -50,
        loglevel: 1
    })
    .setPin("#scrollHorizontal")
    .setTween(scrollHorizontal)
    .addTo(controller);
}

// Function to destroy ScrollMagic
function destroyScrollMagic() {
    if (controller) {
        controller.destroy(true); // Destroy controller and reset scenes
        controller = null;
    }
}

// Media query to detect screen width changes
var mq = window.matchMedia("(min-width: 768px)");

// Function to handle media query changes
function handleWidthChange(mq) {
    if (mq.matches) {
        // Screen width is at least 768px
        initScrollMagic();
    } else {
        // Screen width is less than 768px
        destroyScrollMagic();
    }
}

// Add listener for screen width changes
mq.addListener(handleWidthChange);

// Initial check on page load
handleWidthChange(mq);
*/



/*
        // get all slides
        var slides = document.querySelectorAll(".digit");

        // build scenes
        var revealElements = document.getElementsByClassName("digit");
        for (var i = 0; i < revealElements.length; i++) { // create a scene for each element
            new ScrollMagic.Scene({
                triggerElement: revealElements[i], // y value not modified, so we can use element as trigger as well
                offset: 0,												 // start a little later
                triggerHook: 0.5,
            })
                .setClassToggle(revealElements[i], "visible") // add class toggle
                //.addIndicators({ name: "digit " + (i + 1) }) // add indicators (requires plugin)
                .addTo(controller);
        }


*/



/*
  // get all slides
        var slides2 = document.querySelectorAll(".digitt");
 
        // build scenes
        var revealElements2 = document.getElementsByClassName("digitt");
        for (var i = 0; i < revealElements2.length; i++) { // create a scene for each element
            new ScrollMagic.Scene({
                triggerElement: revealElements2[i], // y value not modified, so we can use element as trigger as well
                offset: 0,												 // start a little later
                triggerHook: 0.5,
            })
                .setClassToggle(revealElements2[i], "visible") // add class toggle
                //.addIndicators({ name: "digitt " + (i + 1) }) // add indicators (requires plugin)
                .addTo(controller);
        }


  // get all slides
        var slides3 = document.querySelectorAll(".digittt");
 
        // build scenes
        var revealElements3 = document.getElementsByClassName("digittt");
        for (var i = 0; i < revealElements3.length; i++) { // create a scene for each element
            new ScrollMagic.Scene({
                triggerElement: revealElements3[i], // y value not modified, so we can use element as trigger as well
                offset: 0,												 // start a little later
                triggerHook: 0.5,
            })
                .setClassToggle(revealElements3[i], "visible") // add class toggle
                //.addIndicators({ name: "digittt " + (i + 1) }) // add indicators (requires plugin)
                .addTo(controller);
        }



*/






        //window on scroll
        window.addEventListener('scroll', function () {

            //toggle skip detail images
            if( document.querySelector('#scrollHorizontal').getBoundingClientRect().top == 50){
                document.querySelector('.skip-detail-slider').classList.remove('skip-detail-slider-off')
            }
            else{
                document.querySelector('.skip-detail-slider').classList.add('skip-detail-slider-off')
            }        
        })




// Select the target element
const detailTrigger = document.querySelector('.detail-trigger');

// Define the observer options
const observerOptionsDetails = {
    root: null, // Use the viewport
    rootMargin: '0px 0px 0px 0px', // No margin
    threshold: 0 // Trigger when any part of the element enters or exits the viewport
};

// Define the callback function
const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
        const isTopEdgeAboveViewport = entry.boundingClientRect.top < 0;
        const isIntersecting = entry.isIntersecting;

        if (!isIntersecting && isTopEdgeAboveViewport) {
            // The element has scrolled out of view upwards
            console.log('Element has scrolled out of view upwards');
            onElementOutOfView();
        } else if (isIntersecting) {
            // The element is in view
            console.log('Element is in view');
            onElementInView();
        }
    });
};



 

        //skip slider

        function skipSlider() {
            document.querySelector('.ppp-detail-datas').scrollIntoView({ behavior: "smooth" });
        }
        document.querySelector('.skip-detail-slider').addEventListener('click', skipSlider)




//toggle specs
/*
document.querySelector('.conf-box-specs').addEventListener('click', function(){
document.querySelector('.conf-box-specs').classList.toggle('conf-specs-closed');
document.querySelector('.techspec-bttn').classList.toggle('techspec-bttn-close');
})

*/


// Check condition
function updateConditionalVisibility(clickedItem) {
    // Remove 'conf-selected' class from all group-itm within the same group and add to the clicked one
    clickedItem.closest('.group').querySelectorAll('.group-itm').forEach(itm => itm.classList.remove('conf-selected'));
    clickedItem.classList.add('conf-selected');

    // Check all conditional elements
    document.querySelectorAll('[data-conditional="true"]').forEach(condElem => {
        const conditionBound = condElem.getAttribute('data-condition-bound');
        const conditions = condElem.getAttribute('data-condition-is').split(';').map(cond => cond.trim());
        const selectedGroupName = clickedItem.closest('.conf-box').querySelector('.subtitle').textContent.trim();
        const selectedGroupValue = clickedItem.querySelector('.group-itm-title').textContent.trim();

        // Initialize a flag to determine visibility
        let shouldBeVisible = false;

        // Check all group-itm elements to see if any meet the condition
        document.querySelectorAll('.group-itm.conf-selected').forEach(selectedItem => {
            const selectedItemGroupName = selectedItem.closest('.conf-box').querySelector('.subtitle').textContent.trim();
            const selectedItemValue = selectedItem.querySelector('.group-itm-title').textContent.trim();

            if (conditionBound === selectedItemGroupName && conditions.includes(selectedItemValue)) {
                shouldBeVisible = true;
            }
        });

        // Update the visibility based on the flag
        if (shouldBeVisible) {
            condElem.classList.remove('hidden');
        } else {
            condElem.classList.add('hidden');
            // Remove 'conf-selected' class from all child group-itm elements
            condElem.querySelectorAll('.group-itm.conf-selected').forEach(childItem => childItem.classList.remove('conf-selected'));
        }
    });
}








        //dynamic add to cart button
        let sizeSelected = 0;
        let colorSelected = 1;
        let configurationSelected = 0;
        document.querySelector('.conf-panel-mobile-bttn').innerText = 'Select size';

        for (let i = 0; i < document.querySelectorAll('.group-itm').length; i++) {
            document.querySelectorAll('.group-itm')[i].addEventListener('click', function () {
                configurationSelected = 1;
                  checkAllOptionsSelected()
                //update options price
                calcOptions()
            })

        }



// updateConditionalVisibility(someGroupItem);

document.querySelectorAll('.group-itm').forEach(item => {
    item.addEventListener('click', () => {
        updateConditionalVisibility(item);
         checkAllOptionsSelected();
       calcOptions()
    });
});


//reset conditions
function resetConditions(){
document.querySelectorAll('.group-itm').forEach(item => {
        updateConditionalVisibility(item);
});

  for (let i = 0; i < document.querySelectorAll('.group-itm').length; i++) {
    document.querySelectorAll('.group-itm')[i].classList.remove('conf-selected')
}
}
resetConditions()



//add to cart when configured
document.querySelector('.add-to-cart-bttn').addEventListener('click', 
function(){
if(document.querySelector('.add-to-cart-bttn').innerText == "Add to Cart"){
addToCartOptions()}
})





document.querySelector('.conf-panel-mobile-bttn').addEventListener('click', 
function(){
if(document.querySelector('.add-to-cart-bttn').innerText == "Add to Cart"){
addToCartOptions()}
})







//function to select recommended setup
/*
function selectRecommended(){
document.querySelectorAll('.recommended').forEach(function(element) {
    element.click();

});
}*/
//selectRecommended();
/*
document.querySelector('.recommended-bttn').addEventListener('click', function(){
  selectRecommended();
    document.querySelector('.recommended-bttn').classList.add('conf-selected');
  document.querySelector('.custom-bttn').classList.remove('conf-selected')
})
 document.querySelector('.recommended-bttn').classList.add('conf-selected');
document.querySelector('.custom-bttn').classList.remove('conf-selected')
*/



//scroll to top
 window.scrollTo(0,0) 







// Cache DOM elements
const myBikeSection = document.querySelector('.ppp-section-mybike');
const titleElement = document.querySelector('.ppp-mybike-content-title');
const imageElement = document.querySelectorAll('.mybike-img');
const textDivs = document.querySelectorAll('.ppp-mybike-content-text div');

// Function to run the animation
function animateMyBikeSection() {
  // Create a timeline with default parameters
  const myAnimation = anime.timeline({
    duration: 300, // Default duration for all animations
    easing: 'linear',
  });

  // Add animations to the timeline
  myAnimation
     .add({
      targets: imageElement,
      scale: [1, 1.07], // Animate from 0 to -80
       delay: 200
    })
    .add({
      targets: textDivs,
      translateY: 20, // Animate from 80 to 0
      opacity: [0, 1],
      delay: anime.stagger(120), // Stagger the animation of each div by 120ms
    }, '-=200');
}

// Function to reset the animation
function resetMyBikeSection() {
  // Animate elements back to their initial state
  anime.timeline({
    duration: 200,
    easing: 'linear',
  })
    .add({
      targets: imageElement,
        scale: [1.07, 1], // Animate from 0 to -80
    }).add({
      targets: textDivs,
      translateY: 00, // Animate from 80 to 0
      opacity: [1, 0],
      delay: anime.stagger(20), // Stagger the animation of each div by 120ms
    })
    ;
}

// Use Intersection Observer to trigger animations
const observerOptions = {
  root: null, // Use the viewport as the container
  threshold: 0.2, // Trigger when 20% of the element is visible
};

const observer2 = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      animateMyBikeSection();
      // Do not unobserve; keep observing for scroll events
       // observer.unobserve(entry.target);
    } else {
      resetMyBikeSection();
    }
  });
}, observerOptions);

// Start observing the section
observer2.observe(myBikeSection);




// Review Swiper
var swiper = new Swiper('.swiper-container', {
  loopedSlides: 9, // Set this to the number of slides you have
  slidesPerView: 1, // Shows 1 slide at a time
  spaceBetween: 20, // Space between slides in pixels
  loop: true,       // Enable looping
  centeredSlides: true,        // Center the active slide
  slideToClickedSlide: true,   // Enable clicking on slides to center them
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  // Enable touch gestures
  allowTouchMove: true,        // Allow touch interactions
  simulateTouch: true,         // Enable touch simulation
  touchRatio: 2,               // Sensitivity of touch interactions
  touchAngle: 45,              // Angle to trigger swipe
  touchEventsTarget: 'container', // Element for touch events
  // Optional: Add responsive breakpoints
  breakpoints: {
    768: {
      slidesPerView: 2, // Show 2 slides for screens >= 768px
    },
    1024: {
      slidesPerView: 3, // Show 3 slides for screens >= 1024px
    },
  },
});





// Gallery Swiper
var swiper2 = new Swiper('.content-detail-images', {
  loopedSlides: 9, // Set this to the number of slides you have
  slidesPerView: 1.25, // Shows 1 slide at a time
  spaceBetween: 20, // Space between slides in pixels
  loop: true,       // Enable looping
  centeredSlides: true,        // Center the active slide
  slideToClickedSlide: true,   // Enable clicking on slides to center them
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  // Enable touch gestures
  allowTouchMove: true,        // Allow touch interactions
  simulateTouch: true,         // Enable touch simulation
  touchRatio: 2,               // Sensitivity of touch interactions
  touchAngle: 45,              // Angle to trigger swipe
  touchEventsTarget: 'container', // Element for touch events
  // Optional: Add responsive breakpoints
  breakpoints: {
    768: {
      slidesPerView: 1.25, // Show 2 slides for screens >= 768px
    },
    1024: {
      slidesPerView: 1.75, // Show 3 slides for screens >= 1024px
    },
     1900: {
      slidesPerView: 1.75, // Show 3 slides for screens >= 1900px
    },
  },
});












// Set up click navigation
//setupClickNavigation();

// Function to switch variants
function switchVariant(variantNumber) {
  const variantGalleries = document.querySelectorAll('.slider-variant-imgs');

  variantGalleries.forEach((gallery) => {
    const variant = gallery.getAttribute('data-variant');
    if (variant === variantNumber.toString()) {
      gallery.classList.remove('hide');
    } else {
      gallery.classList.add('hide');
    }
  });
}

// Example: Switch to variant 2
// switchVariant(2);





function preSelectColor() {
    // Parse the 'color' parameter from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const colorIndex = parseInt(urlParams.get('color'));

    if (!isNaN(colorIndex)) {
        // Select all color options
        const colorOptions = document.querySelectorAll('.conf-color-options .color');

        // Check if the colorIndex is within the range of available colors
        if (colorIndex >= 0 && colorIndex < colorOptions.length) {
            // Remove 'selected' class from all color options
            colorOptions.forEach(option => option.classList.remove('selected'));

            // Add 'selected' class to the desired color option
            colorOptions[colorIndex].classList.add('selected');

            // Simulate a click event to trigger any additional handlers
            colorOptions[colorIndex].click();
        }
    }
}

// Run the function after the DOM content is loaded
document.addEventListener('DOMContentLoaded', preSelectColor);




